module.exports = __webpack_public_path__ + "img/flag-score.7de4c31f.svg";